module.exports = __webpack_public_path__ + "static/media/ACRM_logo.0ccc8d90.png";